//ANIMAZIONI
new WOW().init();

//WELCOME PAGE
$('.btn-welcome').click(function () {
    $('.zushi').hide();
    $('.citta').fadeToggle(1000);
});

// CATEGORIE
if ($(window).width() < 992) {
    $("#show_cat").removeClass("show");
}

// TOOLTIP
var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
});

// VIDEO
var video = document.getElementById("myVideo");

// TO TOP
$(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
        $('.toTop').fadeIn();
    } else {
        $('.toTop').fadeOut();
    }
});

$('.toTop').click(function () {
    $("html, body").animate({scrollTop: 0}, 600);
    return false;
});

// SWIPER
new Swiper('.swiper-container', {
    // Optional parameters
    direction: 'horizontal',
    loop: false,

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

});

//GALLERY SLIDER
function sliderAuto(slider) {
    let slide = 0
    const slides = slider.slides.length - slider.opt.slidesToShow

    setInterval(() => {
        if (slider.slide === slides) {
            slide = 0
            slider.scrollItem(slide)
        } else {
            slide = slide + 1
            slider.scrollItem(slide)
        }
    }, 5000)
};

var gliderElem1 = document.querySelector('.glider');
if (gliderElem1) {
    new Glider(gliderElem1, {
        // Mobile-first defaults
        slidesToShow: 1,
        slidesToScroll: 1,
        scrollLock: true,
        rewind: true,
        arrows: {
            prev: '.glider-prev',
            next: '.glider-next'
        },
        responsive: [
            {
                // screens greater than >= 775px
                breakpoint: 775,
                settings: {
                    // Set to `auto` and provide item width to adjust to viewport
                    slidesToShow: 2,
                    slidesToScroll: 'auto',
                    duration: 0.9,
                    rewind: true
                }
            }, {
                // screens greater than >= 1024px
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    duration: 0.9,
                    rewind: true
                }
            }
        ]
    });
}

var gliderElem2 = document.getElementById('glider');
if (gliderElem2) {
    sliderAuto(new Glider(gliderElem2));
}
